export default __webpack_public_path__ + "static/media/3l-inact.fbc6f23e.svg";